import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import SEO from "../components/SEO";
import ReviewsSection from "../components/ReviewsSection";

export default function FAQ() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/site-settings", { params: { _: Date.now() } }).then((r) => setItems(r.data.faq_items || []));
  }, []);

  const faqLd = items.length > 0 ? {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: items.map((it) => ({
      "@type": "Question",
      name: it.q,
      acceptedAnswer: { "@type": "Answer", text: it.a },
    })),
  } : null;

  return (
    <div className="pt-8 pb-20" data-testid="faq-page">
      <SEO
        title="Časté dotazy o digitálních licencích"
        description="Odpovědi na nejčastější otázky o nákupu, doručení a aktivaci digitálních licenčních klíčů."
        keywords="faq, časté dotazy, licenční klíče, aktivace, faktura"
        jsonLd={faqLd}
      />
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <div className="text-xs uppercase tracking-widest text-blue-600 font-semibold mb-3">FAQ</div>
          <h1 className="font-display text-4xl sm:text-5xl font-bold tracking-tight">Časté dotazy</h1>
          <p className="text-zinc-600 mt-3">Odpovědi na nejčastější otázky o nákupu digitálních licencí.</p>
        </div>
        <Accordion type="single" collapsible className="space-y-3">
          {items.map((it, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="bg-white rounded-2xl border border-zinc-200 px-6">
              <AccordionTrigger className="text-left font-semibold hover:no-underline" data-testid={`faq-q-${i}`}>{it.q}</AccordionTrigger>
              <AccordionContent className="text-zinc-600 leading-relaxed whitespace-pre-line">{it.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
      <div className="mt-16">
        <ReviewsSection/>
      </div>
    </div>
  );
}
